// Funciones de descargas a Excel.
// index.js las pone en el state: se usan como this.$store.state.<función>(...). Son métodos, así que `this` es el state.
import moment from "moment";

export const funcionesExcel = {
  // DESCARGAR EXCEL CONDUCTORES
  async descargarExcelConductores(registros) {
    const XLSX = require("sheetjs-style");
    const cabecera = {
      alignment: {
        vertical: "center",
        horizontal: "center",
        wrapText: true,
      },
      border: {
        top: { style: "thin", color: 1 },
        bottom: { style: "thin", color: 1 },
        left: { style: "thin", color: 1 },
        right: { style: "thin", color: 1 },
      },
      font: {
        name: "Arial",
        sz: 10,
        bold: true,
        color: { rgb: "f3f3f3" },
      },
      fill: {
        type: "pattern",
        patternType: "solid",
        fgColor: { rgb: "073d7a" },
      },
    };
    const contenido = {
      alignment: {
        vertical: "center",
        horizontal: "center",
      },
      border: {
        top: { style: "thin", color: 1 },
        bottom: { style: "thin", color: 1 },
        left: { style: "thin", color: 1 },
        right: { style: "thin", color: 1 },
      },
      font: {
        name: "Arial",
        sz: 10,
        bold: false,
      },
    };
    const workbook = XLSX.utils.book_new();
    const filename = "Registros de Conductores";
    const worksheet = XLSX.utils.json_to_sheet(registros);
    XLSX.utils.sheet_add_aoa(
      worksheet,
      [
        [
          "NOMBRE",
          "NÚMERO DE IDENTIFICACIÓN",
          "DISPOSITIVO / CLIENTE",
          "ESTADO DE LA LICENCIA (A1)",
          "ESTADO DE LA LICENCIA (A2)",
          "ESTADO DE LA LICENCIA (B1)",
          "ESTADO DE LA LICENCIA (B2)",
          "ESTADO DE LA LICENCIA (B3)",
          "ESTADO DE LA LICENCIA (C1)",
          "ESTADO DE LA LICENCIA (C2)",
          "ESTADO DE LA LICENCIA (C3)",
          "ESTADO DE EXAMEN",
          "ESTADO DE CAPACITACIÓN",
          "¿TIENE COMPARENDOS?",
        ],
      ],
      { origin: "A1" },
    );
    var wscols = [
      { wch: 40 },
      { wch: 30 },
      { wch: 30 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
    ];
    worksheet["!cols"] = wscols;
    for (const registro in worksheet) {
      if (typeof worksheet[registro] != "object") continue;
      let cell = XLSX.utils.decode_cell(registro);
      if (worksheet[registro] === worksheet["A1"]) {
        worksheet["A1"].s = cabecera;
      } else if (worksheet[registro] === worksheet["B1"]) {
        worksheet["B1"].s = cabecera;
      } else if (worksheet[registro] === worksheet["C1"]) {
        worksheet["C1"].s = cabecera;
      } else if (worksheet[registro] === worksheet["D1"]) {
        worksheet["D1"].s = cabecera;
      } else if (worksheet[registro] === worksheet["E1"]) {
        worksheet["E1"].s = cabecera;
      } else if (worksheet[registro] === worksheet["F1"]) {
        worksheet["F1"].s = cabecera;
      } else if (worksheet[registro] === worksheet["G1"]) {
        worksheet["G1"].s = cabecera;
      } else if (worksheet[registro] === worksheet["H1"]) {
        worksheet["H1"].s = cabecera;
      } else if (worksheet[registro] === worksheet["I1"]) {
        worksheet["I1"].s = cabecera;
      } else if (worksheet[registro] === worksheet["J1"]) {
        worksheet["J1"].s = cabecera;
      } else if (worksheet[registro] === worksheet["K1"]) {
        worksheet["K1"].s = cabecera;
      } else if (worksheet[registro] === worksheet["L1"]) {
        worksheet["L1"].s = cabecera;
      } else if (worksheet[registro] === worksheet["M1"]) {
        worksheet["M1"].s = cabecera;
      } else if (worksheet[registro] === worksheet["N1"]) {
        worksheet["N1"].s = cabecera;
      } else if (worksheet[registro] === worksheet["!ref"]) {
        worksheet["!ref"];
      } else {
        if (
          cell.c == 3 ||
          cell.c == 4 ||
          cell.c === 5 ||
          cell.c === 6 ||
          cell.c === 7 ||
          cell.c === 8 ||
          cell.c === 9 ||
          cell.c === 10 ||
          cell.c === 11 ||
          cell.c === 12
        ) {
          let bgColor = "70747c";
          let fnColor = "f3f3f3";
          if (worksheet[registro].v === "Vigente") {
            bgColor = "447c64";
          } else if (
            worksheet[registro].v === "Próxima a Vencer" ||
            worksheet[registro].v === "Próximo a Vencer"
          ) {
            bgColor = "daa03b";
            fnColor = "222";
          } else if (
            worksheet[registro].v === "Vencida" ||
            worksheet[registro].v === "Vencido"
          ) {
            bgColor = "be4040";
          }
          if (cell.r) {
            worksheet[registro].s = {
              border: {
                top: { style: "thin", color: 1 },
                bottom: { style: "thin", color: 1 },
                left: { style: "thin", color: 1 },
                right: { style: "thin", color: 1 },
              },
              font: {
                name: "Arial",
                sz: 10,
                bold: true,
                color: { rgb: fnColor },
              },
              alignment: {
                horizontal: "center",
              },
              fill: {
                type: "pattern",
                patternType: "solid",
                fgColor: { rgb: bgColor },
              },
            };
          }
        } else if (cell.c === 13) {
          let bgColor = "447c64";
          if (worksheet[registro].v === "Si") {
            bgColor = "be4040";
          }
          if (cell.r) {
            worksheet[registro].s = {
              border: {
                top: { style: "thin", color: 1 },
                bottom: { style: "thin", color: 1 },
                left: { style: "thin", color: 1 },
                right: { style: "thin", color: 1 },
              },
              font: {
                name: "Arial",
                sz: 10,
                bold: true,
                color: { rgb: "f3f3f3" },
              },
              alignment: {
                horizontal: "center",
              },
              fill: {
                type: "pattern",
                patternType: "solid",
                fgColor: { rgb: bgColor },
              },
            };
          }
        } else {
          worksheet[registro].s = contenido;
        }
      }
    }
    XLSX.utils.book_append_sheet(workbook, worksheet, "CONDUCTORES");
    XLSX.writeFile(workbook, `${filename}.xlsx`);
  },
  // DESCARGAR EXCEL VEHÍCULOS
  async descargarExcelVehiculos(registros, existeAnomalias) {
    const XLSX = require("sheetjs-style");
    const cabecera = {
      alignment: {
        vertical: "center",
        horizontal: "center",
        wrapText: true,
      },
      border: {
        top: { style: "thin", color: 1 },
        bottom: { style: "thin", color: 1 },
        left: { style: "thin", color: 1 },
        right: { style: "thin", color: 1 },
      },
      font: {
        name: "Arial",
        sz: 10,
        bold: true,
        color: { rgb: "f3f3f3" },
      },
      fill: {
        type: "pattern",
        patternType: "solid",
        fgColor: { rgb: "073d7a" },
      },
    };
    const contenido = {
      alignment: {
        vertical: "center",
        horizontal: "center",
      },
      border: {
        top: { style: "thin", color: 1 },
        bottom: { style: "thin", color: 1 },
        left: { style: "thin", color: 1 },
        right: { style: "thin", color: 1 },
      },
      font: {
        name: "Arial",
        sz: 10,
        bold: false,
      },
    };
    const workbook = XLSX.utils.book_new();
    const filename = "Registros de Vehículos";
    const worksheet = XLSX.utils.json_to_sheet(registros);
    XLSX.utils.sheet_add_aoa(
      worksheet,
      [
        [
          "PLACA",
          "MARCA",
          "MODELO",
          "CLASE",
          "DISPOSITIVO / CLIENTE",
          "KILOMETRAJE INICIAL",
          "ÚLTIMO KILOMETRAJE",
          "KILOMETRAJE RECORRIDO",
          "ESTADO DE SOAT",
          "ESTADO DE REVISIÓN TÉCNICO MECÁNICA",
          "ESTADO DE PÓLIZA TODO RIESGO",
          "ESTADO DE PÓLIZA CONTRA ACTUAL",
          "ESTADO DE CARTA DE PROPIEDAD",
          "¿TIENE COMPARENDOS?",
        ],
      ],
      { origin: "A1" },
    );
    var wscols = [
      { wch: 20 },
      { wch: 25 },
      { wch: 20 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 25 },
      { wch: 35 },
      { wch: 35 },
      { wch: 35 },
      { wch: 35 },
      { wch: 25 },
    ];
    worksheet["!cols"] = wscols;

    for (const registro in worksheet) {
      if (typeof worksheet[registro] !== "object") continue;
      let cell = XLSX.utils.decode_cell(registro);
      if (worksheet[registro] === worksheet["A1"] || cell.r === 0) {
        worksheet[registro].s = cabecera;
      } else {
        if (cell.c === 7) {
          if (cell.r) {
            worksheet[registro].s = {
              border: {
                top: { style: "thin", color: 1 },
                bottom: { style: "thin", color: 1 },
                left: { style: "thin", color: 1 },
                right: { style: "thin", color: 1 },
              },
              font: {
                name: "Arial",
                sz: 10,
                bold: worksheet[registro].v < 0 ? true : false,
                color: {
                  rgb: worksheet[registro].v < 0 ? "ffffff" : "222222",
                },
              },
              alignment: {
                horizontal: "center",
              },
              fill: {
                type: "pattern",
                patternType: "solid",
                fgColor: {
                  rgb: worksheet[registro].v < 0 ? "be4040" : "ffffff",
                },
              },
            };
          }
        } else if (
          cell.c == 8 ||
          cell.c == 9 ||
          cell.c === 10 ||
          cell.c === 11
        ) {
          let bgColor = "70747c";
          let fnColor = "f3f3f3";
          if (worksheet[registro].v === "Vigente") {
            bgColor = "447c64";
          } else if (worksheet[registro].v === "Próximo a Vencer") {
            bgColor = "daa03b";
            fnColor = "222";
          } else if (worksheet[registro].v === "Vencido") {
            bgColor = "be4040";
          }
          if (cell.r) {
            worksheet[registro].s = {
              border: {
                top: { style: "thin", color: 1 },
                bottom: { style: "thin", color: 1 },
                left: { style: "thin", color: 1 },
                right: { style: "thin", color: 1 },
              },
              font: {
                name: "Arial",
                sz: 10,
                bold: true,
                color: { rgb: fnColor },
              },
              alignment: {
                horizontal: "center",
              },
              fill: {
                type: "pattern",
                patternType: "solid",
                fgColor: { rgb: bgColor },
              },
            };
          }
        } else if (cell.c === 12) {
          let bgColor =
            worksheet[registro].v === "Registrada" ? "447c64" : "be4040";
          if (cell.r) {
            worksheet[registro].s = {
              border: {
                top: { style: "thin", color: 1 },
                bottom: { style: "thin", color: 1 },
                left: { style: "thin", color: 1 },
                right: { style: "thin", color: 1 },
              },
              font: {
                name: "Arial",
                sz: 10,
                bold: true,
                color: { rgb: "f3f3f3" },
              },
              alignment: {
                horizontal: "center",
              },
              fill: {
                type: "pattern",
                patternType: "solid",
                fgColor: { rgb: bgColor },
              },
            };
          }
        } else if (cell.c === 13) {
          let bgColor = "447c64";
          if (worksheet[registro].v === "Si") {
            bgColor = "be4040";
          }
          if (cell.r) {
            worksheet[registro].s = {
              border: {
                top: { style: "thin", color: 1 },
                bottom: { style: "thin", color: 1 },
                left: { style: "thin", color: 1 },
                right: { style: "thin", color: 1 },
              },
              font: {
                name: "Arial",
                sz: 10,
                bold: true,
                color: { rgb: "f3f3f3" },
              },
              alignment: {
                horizontal: "center",
              },
              fill: {
                type: "pattern",
                patternType: "solid",
                fgColor: { rgb: bgColor },
              },
            };
          }
        } else {
          worksheet[registro].s = contenido;
        }
      }
    }

    const totalKilometraje = registros.reduce(
      (total, item) => total + (item.kilometrajeRecorrido || 0),
      0,
    );
    const ultimaFilaIndice = registros.length + 1;

    XLSX.utils.sheet_add_aoa(
      worksheet,
      [
        [
          `TOTAL DE KILÓMETROS RECORRIDOS HASTA LA FECHA (${moment().format(
            "DD/MM/YYYY",
          )})`,
          "",
          "",
          "",
          "",
          "",
          "",
          totalKilometraje,
        ],
      ],
      { origin: `A${ultimaFilaIndice + 1}` },
    );

    worksheet["!merges"] = worksheet["!merges"] || [];
    worksheet["!merges"].push({
      s: { r: ultimaFilaIndice, c: 0 },
      e: { r: ultimaFilaIndice, c: 6 },
    });

    for (let col = 0; col <= 7; col++) {
      const cellAddress = XLSX.utils.encode_cell({
        r: ultimaFilaIndice,
        c: col,
      });
      worksheet[cellAddress].s = {
        alignment: {
          vertical: "center",
          horizontal: "center",
        },
        font: {
          name: "Arial",
          sz: 10,
          bold: col === 0 || (col === 7 && existeAnomalias) ? true : false,
          color: {
            rgb:
              col === 0
                ? "ffffff"
                : col === 7 && existeAnomalias
                  ? "ffffff"
                  : "000000",
          },
        },
        fill: {
          type: "pattern",
          patternType: "solid",
          fgColor: {
            rgb:
              col === 0
                ? "000000"
                : col === 7 && existeAnomalias
                  ? "be4040"
                  : "fefefe",
          },
        },
        border: {
          top: { style: "thin", color: 1 },
          bottom: { style: "thin", color: 1 },
          left: { style: "thin", color: 1 },
          right: { style: "thin", color: 1 },
        },
      };
    }

    XLSX.utils.book_append_sheet(workbook, worksheet);
    XLSX.writeFile(
      workbook,
      `${filename} (${moment().format("DD/MM/YYYY")}).xlsx`,
    );
  },
  // DESCARGAR EXCEL ASIGNACIONES (CONDUCTORES VS VEHÍCULOS)
  async descargarExcelAsignaciones(asignaciones, sinAsignar, merges) {
    const XLSX = require("sheetjs-style");
    const filename = `Asignaciones Conductores-Vehículos(${moment().format(
      "DD/MM/YYYY HH:mm",
    )})`;

    const cabecera = {
      alignment: { vertical: "center", horizontal: "center", wrapText: true },
      border: {
        top: { style: "thin", color: 1 },
        bottom: { style: "thin", color: 1 },
        left: { style: "thin", color: 1 },
        right: { style: "thin", color: 1 },
      },
      font: { name: "Arial", sz: 10, bold: true, color: { rgb: "f3f3f3" } },
      fill: {
        type: "pattern",
        patternType: "solid",
        fgColor: { rgb: "073d7a" },
      },
    };
    const contenido = {
      alignment: { vertical: "center", horizontal: "center" },
      border: {
        top: { style: "thin", color: 1 },
        bottom: { style: "thin", color: 1 },
        left: { style: "thin", color: 1 },
        right: { style: "thin", color: 1 },
      },
      font: { name: "Arial", sz: 10, bold: false },
    };

    const workbook = XLSX.utils.book_new();

    // ── HOJA 1: ASIGNACIONES ──

    // Fila 1 de cabecera: títulos de grupo
    const headerRow1 = [
      "CONDUCTOR",
      "N° IDENTIFICACIÓN",
      "DISPOSITIVO / CLIENTE",
      "ESTADO DE LICENCIAS",
      "",
      "",
      "",
      "",
      "",
      "",
      "", // D1:K1 → fusionado
      "ESTADO DE EXAMEN",
      "ESTADO DE CAPACITACIÓN",
      "¿COMPARENDOS CONDUCTOR?",
      "PLACA",
      "MARCA / MODELO",
      "CLASE DE VEHÍCULO",
      "ESTADO SOAT",
      "ESTADO REV. TÉC. MEC.",
      "ESTADO CARTA DE PROPIEDAD",
      "¿COMPARENDOS VEHÍCULO?",
    ];

    // Fila 2 de cabecera: subcabeceras de licencias
    const headerRow2 = [
      "",
      "",
      "",
      "(A1)",
      "(A2)",
      "(B1)",
      "(B2)",
      "(B3)",
      "(C1)",
      "(C2)",
      "(C3)",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ];

    // Filas de datos como arrays
    const dataRows = asignaciones.map((row) => [
      row.conductor,
      row.numeroIdentificacion,
      row.dispositivoZonaCliente,
      row.estadoLicenciaA1,
      row.estadoLicenciaA2,
      row.estadoLicenciaB1,
      row.estadoLicenciaB2,
      row.estadoLicenciaB3,
      row.estadoLicenciaC1,
      row.estadoLicenciaC2,
      row.estadoLicenciaC3,
      row.estadoExamen,
      row.estadoCapacitacion,
      row.comparendosConductor,
      row.placa,
      row.marca,
      row.clase,
      row.estadoSoat,
      row.estadoRtm,
      row.estadoCartaPropiedad,
      row.comparendosVehiculo,
    ]);

    const ws1 = XLSX.utils.aoa_to_sheet([
      headerRow1,
      headerRow2,
      ...dataRows,
    ]);

    // Anchos de columna
    ws1["!cols"] = [
      { wch: 40 },
      { wch: 20 },
      { wch: 25 }, // A, B, C
      { wch: 10 },
      { wch: 10 },
      { wch: 10 }, // D, E, F (licencias)
      { wch: 10 },
      { wch: 10 },
      { wch: 10 }, // G, H, I (licencias)
      { wch: 10 },
      { wch: 10 }, // J, K (licencias)
      { wch: 20 },
      { wch: 20 },
      { wch: 20 }, // L, M, N
      { wch: 15 },
      { wch: 20 },
      { wch: 20 }, // O, P, Q
      { wch: 15 },
      { wch: 25 },
      { wch: 20 },
      { wch: 20 }, // R, S, T, U
    ];

    // Merges de cabecera
    const headerMerges = [
      { s: { r: 0, c: 3 }, e: { r: 0, c: 10 } }, // "ESTADO DE LICENCIAS" D1:K1
      { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }, // CONDUCTOR A1:A2
      { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } }, // N° IDENTIFICACIÓN B1:B2
      { s: { r: 0, c: 2 }, e: { r: 1, c: 2 } }, // DISPOSITIVO C1:C2
      { s: { r: 0, c: 11 }, e: { r: 1, c: 11 } }, // ESTADO EXAMEN L1:L2
      { s: { r: 0, c: 12 }, e: { r: 1, c: 12 } }, // ESTADO CAPACITACIÓN M1:M2
      { s: { r: 0, c: 13 }, e: { r: 1, c: 13 } }, // COMPARENDOS CONDUCTOR N1:N2
      { s: { r: 0, c: 14 }, e: { r: 1, c: 14 } }, // PLACA O1:O2
      { s: { r: 0, c: 15 }, e: { r: 1, c: 15 } }, // MARCA P1:P2
      { s: { r: 0, c: 16 }, e: { r: 1, c: 16 } }, // CLASE Q1:Q2
      { s: { r: 0, c: 17 }, e: { r: 1, c: 17 } }, // SOAT R1:R2
      { s: { r: 0, c: 18 }, e: { r: 1, c: 18 } }, // RTM S1:S2
      { s: { r: 0, c: 19 }, e: { r: 1, c: 19 } }, // CARTA DE PROPIEDAD T1:T2
      { s: { r: 0, c: 20 }, e: { r: 1, c: 20 } }, // COMPARENDOS VEHÍCULO U1:U2
    ];
    ws1["!merges"] = [...headerMerges, ...(merges || [])];

    // Estilos — Fila 1 de cabecera (row 0)
    const colsRow1 = [
      "A1",
      "B1",
      "C1",
      "D1",
      "E1",
      "F1",
      "G1",
      "H1",
      "I1",
      "J1",
      "K1",
      "L1",
      "M1",
      "N1",
      "O1",
      "P1",
      "Q1",
      "R1",
      "S1",
      "T1",
      "U1",
    ];
    colsRow1.forEach((col) => {
      if (ws1[col]) ws1[col].s = cabecera;
    });

    // Estilos — Fila 2 de cabecera (row 1): solo las subcabeceras de licencias D2:K2
    const colsRow2 = ["D2", "E2", "F2", "G2", "H2", "I2", "J2", "K2"];
    colsRow2.forEach((col) => {
      if (ws1[col]) ws1[col].s = cabecera;
    });

    // Estilos — Filas de datos (row >= 2)
    for (const celda in ws1) {
      if (typeof ws1[celda] !== "object") continue;
      if (celda === "!ref" || celda === "!cols" || celda === "!merges")
        continue;
      if (colsRow1.includes(celda) || colsRow2.includes(celda)) continue;

      const cell = XLSX.utils.decode_cell(celda);
      if (cell.r < 2) continue; // saltar las dos filas de cabecera

      // Licencias D–K (cols 3–10): Vigente/Próxima a Vencer/Vencida/N/A
      if (cell.c >= 3 && cell.c <= 10) {
        let bg = "91959C";
        if (ws1[celda].v === "Vigente") bg = "447c64";
        else if (ws1[celda].v === "Próxima a Vencer") bg = "daa03b";
        else if (ws1[celda].v === "Vencida") bg = "be4040";
        ws1[celda].s = {
          ...contenido,
          font: {
            name: "Arial",
            sz: 10,
            bold: true,
            color: { rgb: "f3f3f3" },
          },
          fill: {
            type: "pattern",
            patternType: "solid",
            fgColor: { rgb: bg },
          },
        };

        // Examen L (11) y Capacitación M (12): Vigente/Próximo/Vencido/Pendiente
      } else if (cell.c === 11 || cell.c === 12) {
        let bg = "91959C";
        if (ws1[celda].v === "Vigente") bg = "447c64";
        else if (ws1[celda].v === "Próximo a Vencer") bg = "daa03b";
        else if (ws1[celda].v === "Vencido") bg = "be4040";
        ws1[celda].s = {
          ...contenido,
          font: {
            name: "Arial",
            sz: 10,
            bold: true,
            color: { rgb: "f3f3f3" },
          },
          fill: {
            type: "pattern",
            patternType: "solid",
            fgColor: { rgb: bg },
          },
        };

        // Comparendos conductor N (13)
      } else if (cell.c === 13) {
        const bg = ws1[celda].v === "Si" ? "be4040" : "447c64";
        ws1[celda].s = {
          ...contenido,
          font: {
            name: "Arial",
            sz: 10,
            bold: true,
            color: { rgb: "f3f3f3" },
          },
          fill: {
            type: "pattern",
            patternType: "solid",
            fgColor: { rgb: bg },
          },
        };

        // SOAT R (17) y RTM S (18) y Carta de Propiedad T (19)
      } else if (cell.c === 17 || cell.c === 18 || cell.c === 19) {
        let bg = "91959C";
        if (ws1[celda].v === "Vigente" || ws1[celda].v === "Registrada")
          bg = "447c64";
        else if (ws1[celda].v === "Próximo a Vencer") bg = "daa03b";
        else if (
          ws1[celda].v === "Vencido" ||
          ws1[celda].v === "No Registrada"
        )
          bg = "be4040";
        ws1[celda].s = {
          ...contenido,
          font: {
            name: "Arial",
            sz: 10,
            bold: true,
            color: { rgb: "f3f3f3" },
          },
          fill: {
            type: "pattern",
            patternType: "solid",
            fgColor: { rgb: bg },
          },
        };

        // Comparendos vehículo U (20)
      } else if (cell.c === 20) {
        const bg = ws1[celda].v === "Si" ? "be4040" : "447c64";
        ws1[celda].s = {
          ...contenido,
          font: {
            name: "Arial",
            sz: 10,
            bold: true,
            color: { rgb: "f3f3f3" },
          },
          fill: {
            type: "pattern",
            patternType: "solid",
            fgColor: { rgb: bg },
          },
        };
      } else {
        ws1[celda].s = contenido;
      }
    }

    XLSX.utils.book_append_sheet(workbook, ws1, "Asignaciones");

    // ── HOJA 2: VEHÍCULOS SIN ASIGNAR ──
    const ws2 = XLSX.utils.json_to_sheet(sinAsignar);
    XLSX.utils.sheet_add_aoa(
      ws2,
      [
        [
          "PLACA",
          "MARCA / MODELO",
          "CLASE DE VEHÍCULO",
          "ESTADO SOAT",
          "ESTADO REV. TÉC. MEC.",
          "ESTADO CARTA DE PROPIEDAD",
          "¿TIENE COMPARENDOS?",
        ],
      ],
      { origin: "A1" },
    );
    ws2["!cols"] = [
      { wch: 15 },
      { wch: 28 },
      { wch: 25 },
      { wch: 22 },
      { wch: 28 },
      { wch: 20 },
      { wch: 22 },
    ];
    const cabecerasHoja2 = ["A1", "B1", "C1", "D1", "E1", "F1", "G1"];
    cabecerasHoja2.forEach((col) => {
      if (ws2[col]) ws2[col].s = cabecera;
    });
    for (const celda in ws2) {
      if (
        typeof ws2[celda] !== "object" ||
        cabecerasHoja2.includes(celda) ||
        celda === "!ref" ||
        celda === "!cols"
      )
        continue;
      const cell = XLSX.utils.decode_cell(celda);
      if (cell.r === 0) continue;
      if (cell.c === 3 || cell.c === 4) {
        let bg = "91959C";
        if (ws2[celda].v === "Vigente") bg = "447c64";
        else if (ws2[celda].v === "Próximo a Vencer") bg = "daa03b";
        else if (ws2[celda].v === "Vencido") bg = "be4040";
        ws2[celda].s = {
          ...contenido,
          font: { ...contenido.font, bold: true, color: { rgb: "f3f3f3" } },
          fill: {
            type: "pattern",
            patternType: "solid",
            fgColor: { rgb: bg },
          },
        };
      } else if (cell.c === 5) {
        const bg = ws2[celda].v === "Registrada" ? "447c64" : "be4040";
        ws2[celda].s = {
          ...contenido,
          font: { ...contenido.font, bold: true, color: { rgb: "f3f3f3" } },
          fill: {
            type: "pattern",
            patternType: "solid",
            fgColor: { rgb: bg },
          },
        };
      } else if (cell.c === 6) {
        const bg = ws2[celda].v === "Si" ? "be4040" : "447c64";
        ws2[celda].s = {
          ...contenido,
          font: { ...contenido.font, bold: true, color: { rgb: "f3f3f3" } },
          fill: {
            type: "pattern",
            patternType: "solid",
            fgColor: { rgb: bg },
          },
        };
      } else {
        ws2[celda].s = contenido;
      }
    }
    XLSX.utils.book_append_sheet(workbook, ws2, "Sin Asignar");

    XLSX.writeFile(workbook, `${filename}.xlsx`);
  },
};
